import {PermissionScope} from "../../services/auth/permission-scope.enum";
import {PermissionGrant} from "../../services/auth/permission-grant.enum";
import {DtoUtils} from "../../libs/utils/dto.utils";
import {Feature} from "../../libs/enum/feature.enum";
import {isFalse, isTrue} from "../../libs/utils/epic.utils";

export class OrgFeatureDto {

  public readonly id!: string;
  public readonly enabled!: boolean;
  public readonly canceled!: boolean;
  public readonly subscription!: boolean;
  public readonly validFrom: Date | undefined;
  public readonly validUntil: Date | undefined;
  public readonly trial!: boolean;
  public readonly type!: Feature;
  public readonly permissions: Map<PermissionScope, PermissionGrant> = new Map<PermissionScope, PermissionGrant>();

  constructor(init?: Partial<OrgFeatureDto>) {
    Object.assign(this, init);
    if (init?.validFrom) {
      this.validFrom = new Date(init.validFrom);
    }
    if (init?.validUntil) {
      this.validUntil = new Date(init.validUntil);
    }
    if (init?.permissions) {
      this.permissions = DtoUtils.initPermissions(init.permissions);
    } else {
      this.permissions = new Map();
    }
  }

  public isActive(): boolean {
    return isTrue(this.enabled);
  }

  // noinspection JSUnusedGlobalSymbols // Used in Table-Template
  public isSubscriptionRenewal(): boolean {
    return isTrue(this.subscription) && isFalse(this.canceled);
  }

  // noinspection JSUnusedGlobalSymbols // Used in Table-Template
  public isCanceled(): boolean {
    return isTrue(this.canceled);
  }

  // noinspection JSUnusedGlobalSymbols // Used in Table-Template
  public notCanceled(): boolean {
    return !this.isCanceled();
  }

  // noinspection JSUnusedGlobalSymbols // Used in Table-Template
  public isTrial(): boolean {
    return isTrue(this.trial);
  }

  // noinspection JSUnusedGlobalSymbols // Used in Table-Template
  public notTrial(): boolean {
    return !this.isTrial();
  }
}
